import { down } from 'styled-breakpoints';
import styled, { css } from 'styled-components';

import {
    ColProps,
    ContentWrapperProps,
    RowProps,
    SectionProps,
    SpacerProps,
} from './types';

export const StyledSection = styled.section<SectionProps>`
    & > .section-title {
        margin-bottom: 24px;
        font-weight: bold;
    }
    & + section {
        margin-top: ${({ noMargin }) => (noMargin ? undefined : '24px')};
    }
`;

export const StyledRow = styled.div<RowProps>`
    display: flex;
    flex-direction: row;

    align-items: ${({ vAlign = 'flex-start' }) => vAlign};
    justify-content: ${({ hAlign = 'flex-start' }) => hAlign};

    margin: ${(props) => (props.noPadding ? undefined : '-8px')};
    & > div {
        width: ${(props) =>
            props.cols ? `calc(100%/${props.cols})` : undefined};
        padding: ${(props) => (props.noPadding ? undefined : '8px')};
    }
`;

const paddingStyles = css`
    padding-left: calc(16px + env(safe-area-inset-left));
    padding-right: calc(16px + env(safe-area-inset-right));
`;

const paddingStylesWithEnv = css`
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
`;

export const StyledContentWrapper = styled.div<ContentWrapperProps>`
    margin: 0 auto;
    max-width: 576px;
    ${(props) => (props.noPadding ? paddingStylesWithEnv : paddingStyles)};
    width: 100%;
    flex: 1 0 auto;

    display: flex;
    flex-direction: column;
`;

export const StyledCol = styled.div<ColProps>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledSpacer = styled.div<SpacerProps>`
    padding-top: ${({ size }) => (size === '1x' ? '8px' : undefined)};
    padding-top: ${({ size }) => (size === '2x' ? '16px' : undefined)};
    padding-top: ${({ size }) => (size === '3x' ? '24px' : undefined)};
    padding-top: ${({ size }) => (size === '4x' ? '32px' : undefined)};
    padding-top: ${({ size }) => (size === '5x' ? '40px' : undefined)};

    width: 100%;
`;

StyledSpacer.defaultProps = {
    size: '1x',
};

export const StyledTableWrapper = styled.div`
    overflow: auto;
    max-width: 1000px;
    ${down('xxl')} {
        max-width: 600px;
    }
    ${down('xl')} {
        max-width: 500px;
    }
    ${down('lg')} {
        max-width: 100%;
    }
    ${down('md')} {
        max-width: 450px;
    }
    ${down('sm')} {
        max-width: 300px;
    }
    table {
        width: auto;
        tbody {
            th,
            td {
                border: 1px solid #fff;
            }
            tr {
                min-width: 30px;
                min-height: 30px;
            }
            /* tr:nth-child(odd) {
                background: lightblue;
            } */
            th,
            td {
                text-align: center;
                min-width: 30px;
                min-height: 15px;
                height: 15px;
                padding: 0 5px;
            }
        }
    }
`;
